<template>
  <div
    class="wf-event-listing-item-wrapper"
    v-if="eventFilter === 'All' || eventFilter === eventType"
  >
    <slot>
    </slot>
  </div>
</template>

<script>
export default {
  props: [
    'eventType',
    'eventFilter'
  ]
}
</script>